var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7084 14.375V3.95832H2.29169V14.375H17.7084ZM18.9584 14.5C18.9584 15.1213 18.4547 15.625 17.8334 15.625H2.16669C1.54537 15.625 1.04169 15.1213 1.04169 14.5V3.83332C1.04169 3.212 1.54537 2.70832 2.16669 2.70832H17.8334C18.4547 2.70832 18.9584 3.212 18.9584 3.83332V14.5Z",
    fill: "#4B5054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.442 14.558C10.1979 14.314 9.80216 14.314 9.55808 14.558L6.64141 17.4747C6.39733 17.7188 6.39733 18.1145 6.64141 18.3586C6.88549 18.6027 7.28122 18.6027 7.5253 18.3586L10 15.8839L12.4747 18.3586C12.7188 18.6027 13.1146 18.6027 13.3586 18.3586C13.6027 18.1145 13.6027 17.7188 13.3586 17.4747L10.442 14.558Z",
    fill: "#4B5054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.04166C10.3452 1.04166 10.625 1.32148 10.625 1.66666V3.33332C10.625 3.6785 10.3452 3.95832 10 3.95832C9.65484 3.95832 9.37502 3.6785 9.37502 3.33332V1.66666C9.37502 1.32148 9.65484 1.04166 10 1.04166Z",
    fill: "#4B5054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50002 9.37499C7.8452 9.37499 8.12502 9.65481 8.12502 9.99999V11.6667C8.12502 12.0118 7.8452 12.2917 7.50002 12.2917C7.15484 12.2917 6.87502 12.0118 6.87502 11.6667V9.99999C6.87502 9.65481 7.15484 9.37499 7.50002 9.37499Z",
    fill: "#4B5054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.70832C10.3452 7.70832 10.625 7.98814 10.625 8.33332V11.6667C10.625 12.0118 10.3452 12.2917 10 12.2917C9.65484 12.2917 9.37502 12.0118 9.37502 11.6667V8.33332C9.37502 7.98814 9.65484 7.70832 10 7.70832Z",
    fill: "#4B5054"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.04166C12.8452 6.04166 13.125 6.32148 13.125 6.66666V11.6667C13.125 12.0118 12.8452 12.2917 12.5 12.2917C12.1548 12.2917 11.875 12.0118 11.875 11.6667V6.66666C11.875 6.32148 12.1548 6.04166 12.5 6.04166Z",
    fill: "#4B5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.818fee4fb4b54af57bf613e0b586cf31.svg";
export { ForwardRef as ReactComponent };